export type SalaryBasis = "annual" | "monthly" | "daily";
export function salaryToDisplay(
  annual: string,
  basis: "annual" | "monthly",
): string {
  if (!annual) return "";
  return String(
    Number(
      (Number(annual) / (basis === "annual" ? 1000 : 12)).toFixed(
        basis === "annual" ? 3 : 2,
      ),
    ),
  );
}
export function salaryToAnnual(
  value: string,
  basis: "annual" | "monthly",
): string {
  if (!value) return "";
  return String(Math.round(Number(value) * (basis === "annual" ? 1000 : 12)));
}
export function validCompensationRange(min?: string, max?: string) {
  const valid = (value?: string) =>
    !value || (Number.isFinite(Number(value)) && Number(value) >= 0);
  return (
    valid(min) && valid(max) && (!min || !max || Number(min) <= Number(max))
  );
}
